var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-light btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("后退")]),_c('h4',{staticClass:"text-center"},[_vm._v("用户详情 --- "+_vm._s(_vm.id))])])}
var staticRenderFns = []

export { render, staticRenderFns }